import { useCallback } from 'react';
import { coreLocationApi } from '../api';
import { IAddressOption, toAddressOption } from './addressOption';

export const useLocationAutocomplete = (cityId?: number) => {
  const [findLocation] = coreLocationApi.endpoints.getCityLocations.useLazyQuery();
  return useCallback(
    async (address: string): Promise<IAddressOption[]> => {
      const result = await findLocation({ address, cityId: cityId || 0 }, true).unwrap();
      return result.map(toAddressOption);
    },
    [findLocation, cityId],
  );
};
